import type { ICatalog } from '@platform/core/types';
import type { ICustomModuleEntry } from '@platform/navigation/ICustomModuleEntry';

/** Власні модулі каталогу простору (ADR-025): kind 'custom' (сервер без поля kind — ключ mod_…), у порядку каталогу. Чиста функція. */
export function customModuleEntries(catalog: ICatalog): ICustomModuleEntry[] {
  return catalog.modules
    .filter((m) => m.kind === 'custom' || (m.kind == null && m.key.startsWith('mod_')))
    .map((m) => ({ key: m.key, category: m.category }));
}
